import { AspectRatio } from "@/components/ui/aspect-ratio";

interface WebinarVideoPlayerProps {
  recordingUrl: string;
  description?: string;
}

function getEmbedUrl(url: string): { type: "youtube" | "vimeo" | "contrast" | "video"; src: string } {
  // YouTube
  const ytMatch = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  if (ytMatch) {
    return { type: "youtube", src: `https://www.youtube.com/embed/${ytMatch[1]}?rel=0` };
  }

  // Vimeo
  const vimeoMatch = url.match(/(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeoMatch) {
    const params = url.includes('?') ? '&' + url.split('?')[1] : '';
    return { type: "vimeo", src: `https://player.vimeo.com/video/${vimeoMatch[1]}${params ? '?' + url.split('?')[1] : ''}` };
  }

  // Contrast (getcontrast.io)
  if (url.includes("getcontrast.io")) {
    const src = url.includes("/embed/") ? url : url;
    return { type: "contrast", src };
  }

  return { type: "video", src: url };
}

const WebinarVideoPlayer = ({ recordingUrl, description }: WebinarVideoPlayerProps) => {
  const embed = getEmbedUrl(recordingUrl);

  return (
    <section id="webinar-player" className="py-12 sm:py-16 bg-secondary">
      <div className="container mx-auto px-6 lg:px-10 max-w-4xl">
        <AspectRatio ratio={16 / 9} className="rounded-2xl overflow-hidden bg-primary shadow-2xl">
          {embed.type === "video" ? (
            <video
              src={embed.src}
              controls
              className="w-full h-full object-contain"
              preload="metadata"
            />
          ) : (
            <iframe
              src={embed.src}
              title="Webinar recording"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="w-full h-full border-0"
            />
          )}
        </AspectRatio>
      </div>
    </section>
  );
};

export default WebinarVideoPlayer;
